import { render, staticRenderFns } from "./FavoriteContentsNew.vue?vue&type=template&id=2ad80b37&scoped=true&"
import script from "./FavoriteContentsNew.vue?vue&type=script&lang=js&"
export * from "./FavoriteContentsNew.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteContentsNew.vue?vue&type=style&index=0&id=2ad80b37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad80b37",
  null
  
)

export default component.exports